import { render } from "./Accommodation.vue?vue&type=template&id=3b1dfcb6"
import script from "./Accommodation.vue?vue&type=script&lang=js"
export * from "./Accommodation.vue?vue&type=script&lang=js"

import "./Accommodation.vue?vue&type=style&index=0&id=3b1dfcb6&lang=css"

import exportComponent from "E:\\Projects\\Ned-ie\\ned_website-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__